"use client";

import { useEffect, useState } from "react";
import { Box, IconButton } from "@chakra-ui/react";
import { LuArrowUp } from "react-icons/lu";

const SHOW_AT_SCROLL_Y = 360;

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > SHOW_AT_SCROLL_Y);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <Box position="fixed" right={{ base: 4, md: 6 }} bottom={{ base: 5, md: 8 }} zIndex={1200}>
      <IconButton
        variant="outline"
        aria-label="Scroll to top"
        colorPalette="gray"
        rounded="xl"
        size="xs"
        shadow="xs"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <LuArrowUp />
      </IconButton>
    </Box>
  );
}
